import { createAsyncThunk } from "@reduxjs/toolkit";
import i18next from "i18next";
import { toast } from "react-toastify";
import { apiCall } from "services/api";

import { CalendarFilters } from "./types";

export type GoogleCalendarStatus = {
  configured: boolean;
  connected: boolean;
  connected_at: string | null;
};

export const getUserCalendar = createAsyncThunk(
  "/calendar/full",
  async (filters: CalendarFilters, { rejectWithValue }) => {
    try {
      const response = await apiCall().get("/my/calendar-full", {
        params: filters,
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getCalendarDates = createAsyncThunk(
  "/calendar/dates",
  async (filters: CalendarFilters, { rejectWithValue }) => {
    try {
      const response = await apiCall().get("/my/calendar", {
        params: filters,
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getGoogleCalendarStatus = createAsyncThunk(
  "/calendar/google-calendar/status",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall().get("/my/google-calendar/status");
      return response.data.data as GoogleCalendarStatus;
    } catch (error: any) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const connectGoogleCalendar = createAsyncThunk(
  "/calendar/google-calendar/connect",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall().get("/my/google-calendar/connect");
      const url = response.data?.data?.authorization_url;
      if (!url) {
        throw new Error("Missing authorization URL");
      }
      window.location.href = url;
      return response.data;
    } catch (error: any) {
      const message =
        error.response?.data?.message ||
        i18next.t("calendarPage.googleCalendar.connectFailed");
      toast.error(message);
      return rejectWithValue(error.response?.data);
    }
  }
);

export const disconnectGoogleCalendar = createAsyncThunk(
  "/calendar/google-calendar/disconnect",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall().delete("/my/google-calendar/disconnect");
      toast.success(
        response.data?.message ||
          i18next.t("calendarPage.googleCalendar.disconnected")
      );
      return response.data;
    } catch (error: any) {
      const message =
        error.response?.data?.message ||
        i18next.t("calendarPage.googleCalendar.disconnectFailed");
      toast.error(message);
      return rejectWithValue(error.response?.data);
    }
  }
);
